import { FC } from 'react';
import Modal from '../../../../../../components/common/Modal';
import styles from './styles.module.css';
import Button from '../../../../../../components/common/Button';

type Props = {
  requestClose: () => void;
  type: '車両' | 'ドライバー';
};
const EmptySelectModal: FC<Props> = ({ requestClose, type }) => {
  const title =
    type === '車両' ? (
      <div className={styles.modalHead}>使用可能な車両がありません</div>
    ) : (
      <div className={styles.modalHead}>対応可能なドライバーがいません</div>
    );
  const content =
    type === '車両' ? (
      <div className={styles.modalContent}>
        <div>選択中のドライバーが使用可能な車両がありません。</div>
        <div>他のドライバーに変更してください。</div>
      </div>
    ) : (
      <div className={styles.modalContent}>
        <div>選択中の車両で対応可能なドライバーがいません。</div>
        <div>他の車両に変更してください。</div>
      </div>
    );
  return (
    <Modal onRequestClose={requestClose}>
      {title}
      {content}
      <div className={styles.buttons}>
        <div className={styles.button}>
          <Button variants={['fit']} onClick={requestClose}>
            配車前に戻る
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EmptySelectModal;
